import React from 'react';

import { Carousel, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector, useStyle } from 'segments/hooks';

import { selectBookingsWait } from 'features/bookingWait';

import EditBookingWaitForm from './EditBookingWaitForm/EditBookingWaitForm';

interface Props {
  handleCancel: () => void;
}

export const EditBookingWaitModal = ({ handleCancel }: Props) => {
  const { t } = useTranslation();
  const { styles } = useStyle();

  const bookingWaits = useAppSelector(selectBookingsWait);

  if (bookingWaits === null) {
    return;
  }

  if (bookingWaits.length === 0) {
    handleCancel();
  }

  const modalTittle =
    `${t('booking-wait.title.list')} (${bookingWaits.length})`;
  return (
    <Modal
      title={modalTittle}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={false}
      className={styles.customScroolModal}
    >
      <Carousel arrows draggable infinite={false}>
        {
          bookingWaits.map((bookingWait) =>
            <EditBookingWaitForm key={bookingWait.id} initDate={bookingWait} />
          )
        }
      </Carousel>
    </Modal >
  );
};
